import { MutationFunction, useMutation, useQueryClient } from 'react-query';
import { QueryKeySet } from './createQueryKeySet';

interface Params<TData, TVariables> {
  keySet: QueryKeySet;
  mutationFunc: MutationFunction<TData, TVariables>;
  keyExtractor(data: TData, vars: TVariables): string | undefined;
  updater?({ variables, item }: { variables: TVariables; item: TData }): TData;
}

export const createUpdateMutationHook =
  <TData, TVariables>({
    mutationFunc,
    keyExtractor,
    keySet,
  }: Params<TData, TVariables>) =>
  () => {
    const queryClient = useQueryClient();

    return useMutation(mutationFunc, {
      onSuccess(data, vars) {
        const id = keyExtractor(data, vars);

        queryClient.invalidateQueries(keySet.lists());
        queryClient.invalidateQueries(keySet.all_pages());

        if (id) {
          queryClient.invalidateQueries(keySet.detail(id));
        }
      },
    });
  };
